import React from 'react';

import { TableRow, TableHeader } from '@unimed-fesp/components';

const TableHistoricoHeader = () => (
  <TableRow>
    <TableHeader maxWidth={300} minWidth={150}>
      Usuário
    </TableHeader>
    <TableHeader maxWidth={300} minWidth={150}>
      Ação
    </TableHeader>
    <TableHeader maxWidth={300} minWidth={150}>
      Status da Lista
    </TableHeader>
    <TableHeader maxWidth={300} minWidth={150}>
      Data
    </TableHeader>
  </TableRow>
);

export default TableHistoricoHeader;
